import {useEffect, useState} from 'react'
import {CuentaNotaEstructurada} from '../types/types'
import {QueryStatus} from 'src/types'
import {HttpNotaEstructurada} from "../api/httpNotaEstructurada";

export const useCuentas = (idOperacion: number) => {
  const [cuentas, setCuentas] = useState<CuentaNotaEstructurada[]>()
  const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)

  const fetch = () => {
    setStatus(QueryStatus.Loading)

    HttpNotaEstructurada.getCuentas(idOperacion)
      .then(value => {
        setCuentas(value)
        setStatus(QueryStatus.Success)
      })
      .catch(e => {
        setStatus(QueryStatus.Error)
        console.log(e)
      })
  }

  const refetch = () => fetch()

  useEffect(() => {
    fetch()
  }, [idOperacion])

  return {cuentas, refetch, status}
}
